class CacheLoader {
  constructor() {
    this.loadedFiles = [];
    this.products_cache = {};
    this.inline_css = {};

    this.loadFiles = this.loadFiles.bind(this);

    if (window.pending_files && window.pending_files.length) {
      this.loadFiles(window.pending_files);
    }
  }

  loadFiles(fileArr) {
    [...fileArr].forEach(({ type, src }) => {
      if (type === "css") this.css(src);
      if (type === "js") this.js(src);
    });
  }

  fileAlreadyLoaded(src) {
    return this.loadedFiles.includes(src);
  }

  js(src) {
    // console.log('Already Loaded JS:', this.fileAlreadyLoaded(src))

    if (this.fileAlreadyLoaded(src))
      return new Promise((resolve, reject) => resolve());

    return new Promise((resolve, reject) => {
      let $script = document.createElement("script");

      $script.setAttribute("type", "text/javascript");
      $script.setAttribute("src", src);
      $script.setAttribute("defer", "defer");

      $script.onload = function () {
        resolve(true);
      };

      this.loadedFiles.push(src);
      document.getElementsByTagName("head")[0].appendChild($script);
    });
  }

  inlineCss(name, css) {
    if (this.inline_css[name]) return;

    const $style = document.createElement("style");

    $style.type = "text/css";

    if ($style.styleSheet) {
      // This is required for IE8 and below.
      $style.styleSheet.cssText = css;
    } else {
      $style.appendChild(document.createTextNode(css));
    }

    document.getElementsByTagName("head")[0].appendChild($style);
  }

  css(src) {
    if (this.fileAlreadyLoaded(src)) return;

    let $stylesheet = document.createElement("link");

    $stylesheet.setAttribute("rel", "stylesheet");
    $stylesheet.setAttribute("type", "text/css");
    $stylesheet.setAttribute("href", src);

    this.loadedFiles.push(src);
    document.getElementsByTagName("head")[0].appendChild($stylesheet);
  }

  async product(handle) {
    if (this.products_cache[handle]) return this.products_cache[handle];

    let product = await fetch(`/products/${handle}.json`).then((res) =>
      res.json()
    );

    this.products_cache[handle] = product;

    return product;
  }
}

// Initialize Loaders
window.Loaders = new CacheLoader();

// Splide Carousel Custom Element
class SplideCarousel extends HTMLElement {
  constructor() {
    super();

    this.$slides = this.querySelector(".slides");

    this.slidesHTML = this.$slides.innerHTML;

    this.getSettings = this.getSettings.bind(this);
    this.start();
  }

  async start() {
    while (!window.Splide) {
      await sleep(250);
    }

    this.settings = await this.getSettings();

    this.innerHTML = this.renderHtml();

    this.mount();
  }

  async mount() {
    const extensions = {};
    const initEvent = this.dataset.initEvent;
    const hasVideoSlide = this.querySelector(".splide-video__slide");

    console.log("Mounting Carousel Settings", this.settings);

    if (this.settings.autoScroll) {
      await Loaders.js(window.theme.asset_files.slide_extensions.autoplay);
      await Loaders.js(window.theme.asset_files.slide_extensions.intersection);
      extensions.AutoScroll = window.splide.Extensions.AutoScroll;
      extensions.Intersection = window.splide.Extensions.Intersection;
    }

    if (hasVideoSlide) {
      await Loaders.js(window.theme.asset_files.slide_extensions.video);

      extensions.Video = window.splide.Extensions.Video;
      this.settings.video = {
        autoplay: true,
        hideControls: true,
        mute: true,
        loop: true,
        volume: 0,
        playerOptions: {
          htmlVideo: {
            autoplay: true,
            volume: 0,
            controls: false,
            muted: true,
            playsInline: true,
            preload: true,
            loop: true,
          },
        },
      };
    }

    this.splide = new Splide(this.querySelector(".splide"), this.settings);

    this.splide.on("autoplay:play", () => {
      const $btn = this.splide.root.querySelector(".splide-pause-play");

      if (!$btn) return;

      $btn.classList.remove("paused");
      $btn.classList.add("playing");
    });

    this.splide.on("mounted", () => {
      // console.log('Splide Mounted', this.splide);
    });

    this.splide.on("move", (newIndex, prevIndex, destIndex) => {
      const $track = this.querySelector(".splide__track");

      if ($track) $track.style.height = this.children[0]?.clientHeight + "px";
    });

    this.splide.on("autoplay:paused", () => {
      const $btn = this.splide.root.querySelector(".splide-pause-play");

      $btn.classList.remove("playing");
      $btn.classList.add("paused");
    });

    if (this.settings.syncTo) {
      let $splidePartner = document.querySelector(this.settings.syncTo);

      this.splide.sync($splidePartner.splide);
    }

    if (this.settings.syncMovement) {
      let $splidePartner = document.querySelector(this.settings.syncMovement);

      $splidePartner.splide.on("move", (newIndex, prevIndex, destIndex) => {
        let forwardMovement = prevIndex < destIndex;
        let movement = forwardMovement ? ">" : "<";

        this.splide.go(movement);
      });

      this.splide.on("move", (newIndex, prevIndex, destIndex) => {
        let forwardMovement = prevIndex < destIndex;
        let movement = forwardMovement ? ">" : "<";

        $splidePartner.splide.go(movement);
      });
    }

    if (initEvent) {
      if (initEvent === "intersection") {
        const $self = this;
        let intersectionOptions = {
          rootMargin: "0px",
          threshold: 1.0,
        };

        function mountCallback(entries, observer) {
          // console.log('Mount callback', entries);

          let isIntersecting = entries[0].isIntersecting;

          if (isIntersecting) {
            observer.unobserve($self);
            $self.splide.mount(extensions);
            $self.attachHandlers();
          }
        }

        let observer = new IntersectionObserver(
          mountCallback,
          intersectionOptions
        );

        observer.observe(this);
      } else {
        this.addEventListener(initEvent, () => {
          this.splide.mount(extensions);
          this.attachHandlers();
        });
      }
    } else {
      this.splide.mount(extensions);
      // this.attachHandlers();
    }
  }

  attachHandlers() {
    const $autoPlayBtn = this.splide.root.querySelector(".splide-pause-play");
    const $shopBtns = this.splide.root.querySelectorAll(".shop-look-btn");
    const $splideArrows = this.splide.root.querySelectorAll(".splide__arrow");

    if ($autoPlayBtn) {
      $autoPlayBtn.addEventListener("click", () => {
        const $span = $autoPlayBtn.querySelector("span");
        const isPaused = this.splide.s.Autoplay.isPaused();
        const text = isPaused ? "PAUSE" : "PLAY";

        // console.log('Autoplay Buttons Click');

        isPaused
          ? this.splide.s.Autoplay.play()
          : this.splide.s.Autoplay.pause();

        if (isPaused) {
          $autoPlayBtn.classList.remove("paused");
          $autoPlayBtn.classList.add("playing");
        } else {
          $autoPlayBtn.classList.remove("playing");
          $autoPlayBtn.classList.add("paused");
        }

        if ($span) {
          $span.textContent = text;
        }
      });
    }

    if ($shopBtns.length) {
      [...$shopBtns].forEach(($btn) =>
        $btn.addEventListener("click", this.handleShopClick.bind(this))
      );
    }

    if ($splideArrows.length) {
      [...$splideArrows].forEach(($arrow) =>
        $arrow.addEventListener("click", (e) => e.preventDefault())
      );
    }
  }

  createShopModal(products) {
    let id = window.utils.createGuid();
    const $modal = document.createElement("quick-shop-modal");

    document.body.appendChild($modal);
  }

  handleShopClick(event) {
    event.preventDefault();

    const $btn = event.target;
    const handlesStr = $btn.dataset.handles;
    const handles = handlesStr
      .split(",")
      .map((str) => str.trim())
      .filter((str) => str.length);

    // console.log('Handle Shop click', { handles });

    this.createShopModal();
  }

  async getSettings() {
    const $script = this.querySelector("script[data-settings]");

    try {
      let settings = JSON.parse($script.innerHTML);

      // /      console.log("SPLIDE SETTINGS:", settings);

      if (settings.breakpoints) {
        settings.breakpoints = [...Object.keys(settings.breakpoints)].reduce(
          (breakpoints, breakpoint) => {
            breakpoints[Number(breakpoint)] = {
              ...settings.breakpoints[breakpoint],
            };

            Object.keys(breakpoints[Number(breakpoint)]).forEach((key) => {
              let isBooleanValue =
                breakpoints[Number(breakpoint)][key] === "true" ||
                breakpoints[Number(breakpoint)][key] === "false";

              if (isBooleanValue) {
                breakpoints[Number(breakpoint)][key] =
                  breakpoints[Number(breakpoint)][key] === "true";
              }
            });

            return breakpoints;
          },
          {}
        );

        if (settings.breakpoints[0]) delete settings.breakpoints[0];
      }

      if (settings.heightRatio === 0) delete settings.heightRatio;

      if (settings.autoplay) {
        settings.pauseOnHover = false;
      }
      // console.log('Settings', settings, settings.autoScroll);

      return settings;
    } catch (error) {
      return {};
    }
  }

  getElementAsHtml($el) {
    if (!$el) return "";

    let $temp = document.createElement("div");

    $temp.appendChild($el.cloneNode(true));

    return $temp.innerHTML;
  }

  renderHtml() {
    return `
      <div class="splide generated">
        <div class="splide__track">
          <ul class="splide__list">${this.slidesHTML}</ul>
        </div>
        ${
          this.querySelector(".splide__arrows")
            ? this.getElementAsHtml(this.querySelector(".splide__arrows"))
            : ""
        }
        ${this.getElementAsHtml(
          this.querySelector(".splide-autoplay-controls")
        )}
      </div>
      `;
  }
}

customElements.define("splide-carousel", SplideCarousel);
